export default {
  loading: false,
  modules: [],
  role: {},
  permissions: [],
  levelPermissions: [],
};
